'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.confirmEmailOnEnterSaga = confirmEmailOnEnterSaga;

var _effects = require('redux-saga/effects');

var _helpers = require('redux/saga/helpers');

var _localStorage = require('redux/saga/helpers/local-storage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(confirmEmailOnEnterSaga);

function confirmEmailOnEnterSaga(client, nextState) {
  var cookieValue, result;
  return _regenerator2.default.wrap(function confirmEmailOnEnterSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(__SERVER__ && !__TEST__)) {
            _context.next = 2;
            break;
          }

          return _context.abrupt('return');

        case 2:
          cookieValue = 'update_email_failure';
          _context.prev = 3;
          _context.next = 6;
          return (0, _effects.call)(client.users.confirmEmailToken, nextState.params.key);

        case 6:
          result = _context.sent;

          cookieValue = result.email;
          _context.next = 12;
          break;

        case 10:
          _context.prev = 10;
          _context.t0 = _context['catch'](3);

        case 12:
          _context.next = 14;
          return (0, _effects.call)(_localStorage.writeLocalStorage, 'cpChangeEmail', cookieValue);

        case 14:
          _context.next = 16;
          return (0, _effects.call)(_helpers.gtmSafeRedirect, '/settings/account');

        case 16:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[3, 10]]);
}